console.log("Synapse UI application.js is loaded"); // Show spinner on page refresh

$(document).on('turbolinks:load', function () {
  // hide spinner when a page is loaded
  $(".spinner").hide();
});
$(document).on('turbolinks:click', function () {
  // show spinner when a Turbolinks link is clicked
  $(".spinner").show();
}); // Show spinner during AJAX requests

$(document).on('turbolinks:load', function () {
  // hide spinner to start
  $(".spinner").hide(); // show spinner on AJAX start

  $(document).ajaxStart(function () {
    $(".spinner").show();
  }); // hide spinner on AJAX stop

  $(document).ajaxStop(function () {
    $(".spinner").hide();
  });
}); // Direct uploads

addEventListener("direct-upload:initialize", function (event) {
  var target = event.target,
      detail = event.detail;
  var id = detail.id,
      file = detail.file;
  target.insertAdjacentHTML("beforebegin", "\n    <div id=\"direct-upload-".concat(id, "\" class=\"direct-upload direct-upload--pending\">\n      <div id=\"direct-upload-progress-").concat(id, "\" class=\"direct-upload__progress\" style=\"width: 0%\"></div>\n      <span class=\"direct-upload__filename\">").concat(file.name, "</span>\n    </div>\n  "));
});
addEventListener("direct-upload:start", function (event) {
  var id = event.detail.id;
  var element = document.getElementById("direct-upload-".concat(id));
  element.classList.remove("direct-upload--pending");
});
addEventListener("direct-upload:progress", function (event) {
  var _event$detail = event.detail,
      id = _event$detail.id,
      progress = _event$detail.progress;
  var progressElement = document.getElementById("direct-upload-progress-".concat(id));
  progressElement.style.width = "".concat(progress, "%");
});
addEventListener("direct-upload:error", function (event) {
  event.preventDefault();
  var _event$detail2 = event.detail,
      id = _event$detail2.id,
      error = _event$detail2.error;
  var element = document.getElementById("direct-upload-".concat(id));
  element.classList.add("direct-upload--error");
  element.setAttribute("title", error);
});
addEventListener("direct-upload:end", function (event) {
  var id = event.detail.id;
  var element = document.getElementById("direct-upload-".concat(id));
  element.classList.add("direct-upload--complete");
});